export const SETTINGS_PAGES = Object.freeze({
  HUB: "hub",
  APP_MODE: "app-mode",
  APPEARANCE: "appearance",
  PUSH: "push",
});
